<template>
  <div v-if="data">
    <a @click.prevent="movePlay(data)" href="#">
      <span class="my-history-list">
          <span class="con-img thumb-image">
            <img v-lazy="getLazyLoadObj(data)" :alt="data.episodetitle"/>
            <span class="progress-bar-wrap" v-if="data.viewratio"><span class="progress-bar" :style="'width:' + viewRatio + '%;'"></span></span>
            <age-limits :targetAge="+data.targetage" :contentType="viewMode"/>
            <div :class="adultDimClass"></div>
          </span>
          <span class="my-history-check check-style" v-if="editorMode">
            <input type="checkbox" name="chkSeq" :value="data.contentid" v-model="data.checked"
                   :id="'ch-'+data.contentid" class="check-blue-dark"><label :for="'ch-'+data.contentid"><span>선택</span></label>
          </span>
          <span class="con-text-wrap">
            <strong class="con-tit"><template v-if="data.episodenumber && data.episodenumber !== '0'">{{data.episodenumber}}회</template> {{data.programtitle}}</strong>
            <span class="con-text01">
              <span>이용일시</span>
              <span class="title-dot"></span>
              <span>{{data.viewdate}}</span>
            </span>
          </span>
        </span>
    </a>
  </div>
</template>

<script>
import AgeLimits from '@/components/model/AgeLimits'
import { addPostfixAndUrl } from '@/common/utils/common'
import breakDown from '@/mixins/breakdown.mixin'
import { resizeThumbnail } from '@/common/utils/image'
import cookie from '@/common/utils/cookie'
import _ from 'lodash'
import { PATH_NAME_PLAYER_VOD } from '@/common/resources/router.const'
export default {
  name: 'BreakListVod',
  filters: {
    addPostfixAndUrl
  },
  mixins: [
    breakDown
  ],
  components: {
    AgeLimits
  },
  props: {
    data: {
      type: Object
    },
    index: {
      type: Number
    },
    editorMode: {
      type: Boolean
    },
    viewMode: {
      type: String
    },
    setCheckFn: {
      type: Function
    }
  },
  data () {
    return {
      placeholderImage: require('../../../assets/images/common/img_default_thum_2.png')
    }
  },
  computed: {
    adultDimClass () {
      return cookie.isNotVerifiedAdultUser() && _.get(this.data, 'targetage', 0) >= 21 ? 'vod-lock-21' : ''
    }
  },
  methods: {
    movePlay (data) {
      if (data.programtitle === '방송정보가 없습니다.') {
        alert('콘텐츠 상세정보가 없습니다.')
        return
      }
      if (this.editorMode) {
        this.setCheckFn(data.contentid)
      } else {
        this.$router.push({
          name: PATH_NAME_PLAYER_VOD,
          query: {
            contentid: data.contentid
          }
        })
      }
    },
    getLazyLoadObj (vodItem) {
      return {
        src: resizeThumbnail(vodItem.image, { width: 242, height: 136, isSquare: false }),
        error: this.placeholderImage,
        loading: this.placeholderImage
      }
    }
  }
}
</script>
